import styled, { css } from 'styled-components';

export const MessageStyled = styled.p`
  margin: 0;
  font-family: ${props => props.theme.fonts.gtEesti};
  font-size: 16px;
  line-height: 18px;
  
  ${props =>
    props.type === 'alert' &&
    css`
      color: ${props.theme.colors.danger};
    `}
  
  ${props =>
    props.type === 'success' &&
    css`
      color: ${props.theme.colors.success};
    `}
  
  ${props =>
    props.type === 'help' &&
    css`
      color: ${props.white ? props.theme.colors.white : 'rgb(0,0,0,0.5)'};
      font-size: 13px;
      line-height: 15px;
    `}

`;
